import PropTypes from 'prop-types'
import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { recommend, VOTE_DIRECTION_UP } from 'services/recommend'
import _partial from 'lodash/partial'
import _isArray from 'lodash/isArray'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

function renderLabel (text, extraClass) {
  const baseClass = ['thumbs-up__label']

  if (extraClass && _isArray(extraClass)) {
    baseClass.push(extraClass)
  }

  if (!text) {
    return null
  }
  return <span className={baseClass.join(' ')}>{text}</span>
}

function renderCount (num, units, extraClass) {
  const baseClass = ['thumbs-up__value']

  if (extraClass && _isArray(extraClass)) {
    baseClass.push(extraClass)
  }

  if (typeof num !== 'number') {
    return null
  }

  const display = units ? `${num}${units}` : num
  return <span className={baseClass.join(' ')}>{display}</span>
}

function getIconClass (extraClass) {
  const iconClass = ['thumbs-up__icon']

  if (extraClass && _isArray(extraClass)) {
    iconClass.push(extraClass)
  }

  return iconClass.join(' ')
}

function getClassName (props) {
  const className = ['thumbs-up']
  if (props.thumbsUpClass && _isArray(props.thumbsUpClass)) {
    className.push(props.thumbsUpClass)
  }
  if (!props.auth.get('jwt')) {
    className.push('thumbs-up--anonymous')
  }
  if (!props.canVote) {
    className.push('thumbs-up--inactive')
  }
  return className.join(' ')
}

function incrementVote (props, score, onVote) {
  if (typeof onVote === 'function') {
    onVote()
  }

  recommend({ id: props.voteId, auth: props.auth.get('jwt'), vote: score })
}

function ThumbsUp (props) {
  const {
    vote,
    onVote,
    canVote,
    text,
    units,
    score,
    iconClass,
    voteClass,
    labelClass,
    hideResult,
  } = props

  const onClick = canVote
    ? _partial(incrementVote, props, score, onVote)
    : null
  const className = getClassName(props)

  return (
    <div className={className} onClick={onClick}>
      <IconV2 className={getIconClass(iconClass)} type={ICON_TYPES.RECOMMEND}/>
      {!hideResult && renderCount(vote, units, voteClass)}
      {renderLabel(text, labelClass)}
    </div>
  )
}

ThumbsUp.propTypes = {
  hideResult: PropTypes.bool,
  vote: PropTypes.number.isRequired,
  thumbsUpClass: PropTypes.array,
  text: PropTypes.string,
  iconClass: PropTypes.array,
  labelClass: PropTypes.array,
  voteClass: PropTypes.array,
  voteId: PropTypes.number.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  units: PropTypes.string,
  onVote: PropTypes.func,
  score: PropTypes.number,
  canVote: PropTypes.bool.isRequired,
}

ThumbsUp.defaultProps = {
  score: VOTE_DIRECTION_UP,
  canVote: true,
}

export default React.memo(ThumbsUp)
